const defaultSocialHeaderButtonAttributes = {
  onlyInside: "SocialButtonsFooterWidget",
  attributes: {
    title: "string",
    body: "html",
    link: "link",
  },
  extractTextAttributes: ["title", "body"],
};

export default defaultSocialHeaderButtonAttributes;
